import { Component } from 'react'
import { withRouter } from 'hocs'
import { LoginForm } from './LoginForm'
import { isAuthenticated, logout } from 'utils/authService'
import * as ACT from './actions'
import { connect } from 'react-redux'
import { loginRedirect } from 'utils/api'
import { PageTitle } from 'components/common/PageTitle'

@connect()
@withRouter
class Login extends Component {
  async componentDidMount() {
    if (isAuthenticated()) {
      loginRedirect(this.props.router.navigate)
    } else {
      await logout()
    }
  }

  formSubmit = async (values, { onError } = {}) => {
    this.props.dispatch({
      type: ACT.LOGIN_REQUESTED,
      payload: {
        ...values,
        onError,
        navigate: this.props.router.navigate
      }
    })
  }

  render() {
    return (
      <>
        <PageTitle
          detail="Login or Sign Up for Your iDeal Construction CRM Account"
          description="Create an account for iDeal Construction CRM and start managing your opportunities, bids, jobs, projects, and proposals. Expedite and automate follow-up."
        />
        <LoginForm formSubmit={this.formSubmit} />
      </>
    )
  }
}

export default Login
